import { render, staticRenderFns } from "./EditarEscalasDepartamento.vue?vue&type=template&id=4d9cce75"
import script from "./EditarEscalasDepartamento.vue?vue&type=script&lang=js"
export * from "./EditarEscalasDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports